import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';

import { router } from './routes/mainRoutes'
import { store } from './store/store'
import moment from 'moment';
import vueVimeoPlayer from 'vue-vimeo-player';
import axios from 'axios'
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel)
import 'material-design-icons-iconfont/dist/material-design-icons.css'


import Vuelidate from 'vuelidate'

import JsonExcel from 'vue-json-excel'

import "@/plugins/echarts";

import DatetimePicker from 'vuetify-datetime-picker'

//session
import VueSession from 'vue-session'
var options = {
    persist: true
}
Vue.use(VueSession, options)
    //clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(vueVimeoPlayer)
Vue.use(VueClipboard)
    //end
Vue.use(DatetimePicker)

Vue.component('downloadExcel', JsonExcel)

Vue.use(Vuelidate)
    //graph
import DrVueEcharts from 'dr-vue-echarts';

Vue.use(DrVueEcharts)

//timer 
import VueTimers from 'vue-timers'

Vue.use(VueTimers)
    //
    // import CKEditor from '@ckeditor/ckeditor5-vue';

// Vue.use(CKEditor);


import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

import VueMathjax from 'vue-mathjax';
Vue.use(VueMathjax);
//breadcrums
import VueBreadcrumbs from 'vue-2-breadcrumbs';

Vue.use(VueBreadcrumbs);
//end
//countdown
import VueCountdownTimer from 'vuejs-countdown-timer'
Vue.use(VueCountdownTimer)
    //end
    //equation
    // import VueMathjax from 'vue-mathjax';
    // Vue.use(VueMathjax);
    //end
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});
//video
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

const hls = require('videojs-contrib-hls')
   Vue.use(hls)
//ends
//youtube
import LazyYoutubeVideo from 'vue-lazy-youtube-video'
 
Vue.component('LazyYoutubeVideo', LazyYoutubeVideo)
//end

//lazy
// import VueLazyload from 'vue-lazyload'

// Vue.use(VueLazyload)
//ends
//html2canvas
// import VueHtml2Canvas from 'vue-html2canvas';

// Vue.use(VueHtml2Canvas);
//ends
//encryption
import { sha256 } from 'js-sha256';
//ends
//recaptha
import { VueReCaptcha } from 'vue-recaptcha-v3'
 
// For more options see below
// Vue.use(VueReCaptcha, { siteKey: '6LeH0XYaAAAAAD3QGG-nKXtUtH3Gr89-qdxVSG5d' })
//ends
/*---------Custom/3rd Party Library CSS and Javascript can be added here -----*/
import JQuery from 'jquery'
window.$ = JQuery;

import "bootstrap";
import "popper.js";

import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-reboot.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "@/assets/css/web.css";
/*---------End Custom/3rd Party Library CSS and Javascript can be added here -----*/


Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home //live or local
    //axios.defaults.baseURL = process.env.VUE_APP_API_URL_BETA //beta
const session = Vue.prototype.$session

axios.interceptors.request.use(config => {
    console.log("in inst-req")
    if (!navigator.onLine) {
        alert("You are offline!!!")
        return
    }
    config.headers.common['organization-code'] = localStorage.getItem('organization-code')
    if (session.exists()) { //dashboard
        /*if (session.has('ut')) {
            if (session.get('ut') == "Learner") {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL_Stud
            } else if (session.get('ut') == "Instructor") {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL_Inst
            } else if (session.get('ut') == "Admin") {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL_Inst
            } else if (session.get('ut') == "SuperAdmin") {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL_Inst
            } else {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home
            }
        }*/
        if (session.has('token')) {
            config.headers.common['token'] = session.get('token')
        }
        if (session.has('uid')) {
            config.headers.common['uid'] = session.get('uid')
        }
        if (session.has('ut')) {
            config.headers.common['ut'] = session.get('ut')
        }
    } else {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL_Home
    }
    config.headers.common['router-path'] = router.currentRoute.path
    config.headers.common['device'] = "Web"
    return config
})

axios.interceptors.response.use(res => {
   // console.log(res.data)
   // console.log("res-url:" + res.data.platform_notification)
    //console.log("res-status:" + res.status)
    if(res.data.platform_notification != undefined && store.getters.notification!=res.data.platform_notification){
        store.commit("setnotification", res.data.platform_notification);
        store.dispatch('setSnackbar',{
          showing:true,
          timeout:50000,
          color:'yellow',
          text:res.data.platform_notification,
        })
    }
    if (res.data.status == "200") {
        //success
        // store.dispatch('setSnackbar',{
        //   showing:true,
        //   timeout:5000,
        //   color:'#008000',
        //   text:"success..."
        // })
    } else if (res.data.status == "100") { //token refreshed
        session.set("token", res.data.token)
    } else if (res.data.status == "401") {
        store.dispatch('setSnackbar', {
            showing: true,
            timeout: 5000,
            color: '#e60000',
            text: "You have already logged in other device. Please login again..."
        })
        router.push("/")
    } else if (res.data.status == "402") {
        store.dispatch('setSnackbar', {
            showing: true,
            timeout: 5000,
            color: '#e60000',
            text: "Organization is not set..."
        })
        router.push("/")
    } else if (res.data.status == "405") {
        store.dispatch('setSnackbar', {
            showing: true,
            timeout: 5000,
            color: '#e60000',
            text: "Access Denied!!!"
        })
        router.push("/")
    }else if (res.data.status == "406") {
        store.dispatch('setSnackbar', {
            showing: true,
            timeout: 5000,
            color: '#e60000',
            text: "Tenant not found. Please contact admin..."
        })
        router.push("/")
    }else if (res.data.status == "501") {
        store.dispatch('setSnackbar', {
            showing: true,
            timeout: 5000,
            color: '#e60000',
            text: "Un-Authorized Access"
        })
        router.push("/volp-super-admin")
    }

    return res
})

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')